<script>
import store from '@state/store'
import {
  adminNotificationAgentComputed,
  adminNotificationAgentMethods,
} from '@state/helpers/admin-notification-agent'
import {
  notificationComputed,
  notificationMethods,
} from '@state/helpers/notification'
import SearchPayload from '@utils/searchPayload'
import tableFields from '@views/NotificationAgentAdmin/table-fields'
import configChart from '@views/NotificationAgentAdmin/config-chart'
import PopupFilter from '@views/NotificationAgentAdmin/list/popup-filter.vue'
import DateTimeFormatRangerOnTable from '@components/molecules/date-time-format-ranger-on-table.vue'
import { ROLE } from '@utils/constant'
import { addParamsToLocation } from '@utils/helpers'

export default {
  page: {
    title: 'Notification Agent Admin',
    meta: [
      { name: 'description', content: 'The Notification Agent Admin page.' },
    ],
  },
  components: {
    PopupFilter,
    DateTimeFormatRangerOnTable,
  },
  data() {
    return {
      currentUser: store.getters['auth/getCurrentUser'],
      optionsStatus: [
        {
          label: '',
          value: '',
        },
        {
          label: '配信待ち',
          value: '0',
        },
        {
          label: '配信中',
          value: '1',
        },
        {
          label: '配信終了',
          value: '2',
        },
        {
          label: '無効化',
          value: '3',
        },
        {
          label: '無効化申請中',
          value: '4',
        },
      ],
      searchBody: new SearchPayload.Builder().withAgentId().withStatus(),
      fields: tableFields,
      filtered: false,
      showFilter: false,
    }
  },
  computed: {
    ...adminNotificationAgentComputed,
    ...notificationComputed,
    isShowEditButton() {
      return this.currentUser.level !== ROLE.AGENT_AUDIT
    },
    notificationList() {
      return this.getNotificationList
    },
    paginationComputed() {
      return this.getNotificationPaginate
    },
    listItemChart() {
      return this.getChartDataNotificationAgentAdmin?.data
    },
    dataChart() {
      const dataChart = this.getChartDataNotificationAgentAdmin
      if (!dataChart) {
        return {
          labels: [],
          chartData: [],
          chartDataRead: [],
          chartDataReadRate: [],
          chartDataClick: [],
          chartDataClickRate: [],
        }
      }
      const data = dataChart.data.slice(-10)

      const labels = []
      const chartData = []
      const chartDataRead = []
      const chartDataReadRate = []
      const chartDataClick = []
      const chartDataClickRate = []

      for (let i = 0; i < data.length; i++) {
        labels.push(data[i].label)
        const value = data[i].value || {}
        chartData.push(value.notification_count || 0)
        chartDataRead.push(value.notification_read || 0)
        chartDataReadRate.push(value.notification_read_rate || 0)
        chartDataClick.push(value.clicks || 0)
        chartDataClickRate.push(value.clicks_rate || 0)
      }
      return {
        labels,
        chartData,
        chartDataRead,
        chartDataReadRate,
        chartDataClick,
        chartDataClickRate,
      }
    },
  },
  watch: {
    searchBody() {
      addParamsToLocation(this.$route, this.searchBody)
    },
  },
  created() {
    const filter = this.$route.query
    if (filter.page_no) {
      filter.page_no = parseInt(filter.page_no, 10)
      filter.lines = parseInt(filter.lines, 10)
      for (const key in filter) {
        if (filter[key] === 'undefined') {
          filter[key] = ''
        }
        if (key !== 'page_no' && key !== 'lines') {
          if (filter[key] !== '' && filter[key] !== undefined) {
            this.searchBody = filter
            this.filtered = true
          }
        }
      }
      if (filter.page_no > 1) {
        this.searchBody = filter
      }
    }
    this.fetchingChartDataNotificationAgentAdmin()
    this.handleSearchNotification()
    const user = this.$store.getters['auth/getCurrentUser']
    this.$router
      .replace({
        query: { ...this.$route.query, agent_code: user?.agent?.agent_code },
      }) // eslint-disable-next-line handle-callback-err
      .catch(() => {})
  },
  methods: {
    ...adminNotificationAgentMethods,
    ...notificationMethods,
    optionsChartsOverviewClick: configChart.optionsChartsOverviewClick,
    optionsChartsOverviewRead: configChart.optionsChartsOverviewRead,
    optionsChartsOverviewCount: configChart.optionsChartsOverviewCount,
    datasetChartsOverviewCount: configChart.datasetChartsOverviewCount,
    datasetChartsOverviewRead: configChart.datasetChartsOverviewRead,
    datasetChartsOverviewClick: configChart.datasetChartsOverviewClick,
    handlePagination(body) {
      this.searchBody = { ...this.searchBody, ...body }
      this.handleSearchNotification()
    },
    handleSorter(key) {
      if (!~key.indexOf('notification_id')) {
        this.searchBody = { ...this.searchBody, order_by: key }
      } else {
        const id = key[key.length - 1] === '-' ? 'id-' : 'id'
        this.searchBody = { ...this.searchBody, order_by: id }
      }
      this.handleSearchNotification()
    },
    handleSearchNotification() {
      const agentId = this.currentUser.agent.id
      this.searchBody = { ...this.searchBody, ...{ agent_id: agentId } }
      this.fetchingNotificationList(this.searchBody)
    },
    handleFilter(params, reset = false) {
      this.searchBody = { ...this.searchBody, ...params }
      this.handleSearchNotification()
      this.filtered = !reset
    },
  },
}
</script>

<template>
  <div id="admin-notification-agent">
    <div>
      <BaseCardCollapse title="Overview" form-collapsed>
        <template>
          <div class="row">
            <div class="col-xl-4">
              <BaseCard :title="'配信数'">
                <template>
                  <CChartBar
                    style="height:200px"
                    :datasets="datasetChartsOverviewCount(dataChart.chartData)"
                    :labels="dataChart.labels"
                    :options="optionsChartsOverviewCount(listItemChart)"
                  />
                </template>
              </BaseCard>
            </div>
            <div class="col-xl-4">
              <BaseCard :title="'閲覧数/閲覧率'">
                <template>
                  <CChartBar
                    style="height:200px"
                    :datasets="
                      datasetChartsOverviewRead(
                        dataChart.chartDataReadRate,
                        dataChart.chartDataRead
                      )
                    "
                    :labels="dataChart.labels"
                    :options="optionsChartsOverviewRead(listItemChart)"
                  />
                </template>
              </BaseCard>
            </div>
            <div class="col-xl-4">
              <BaseCard :title="'クリック数/クリック率'">
                <template>
                  <CChartBar
                    style="height:200px"
                    :datasets="
                      datasetChartsOverviewClick(
                        dataChart.chartDataClickRate,
                        dataChart.chartDataClick
                      )
                    "
                    :labels="dataChart.labels"
                    :options="optionsChartsOverviewClick(listItemChart)"
                  />
                </template>
              </BaseCard>
            </div>
          </div>
        </template>
      </BaseCardCollapse>
    </div>
    <div>
      <BaseCardDetail title="お知らせ一覧" form-collapsed>
        <template v-slot:header-action>
          <div class="btn-group float-right">
            <CButton
              v-if="isShowEditButton"
              class="btn-outline-dark"
              @click="
                $router.push({ name: 'notificationAgentAdminRegistration' })
              "
            >
              新規登録
            </CButton>
            <PopupFilter
              :has-left-button="isShowEditButton"
              @submit:search="handleFilter"
            />
          </div>
        </template>
        <template>
          <BasePagination
            :paginations="paginationComputed"
            :searching="filtered"
            @activePagination="handlePagination"
          />
          <BaseTable
            striped
            border
            :table-fields="fields"
            :data-tables="notificationList"
            @sorterBy="handleSorter"
          >
            <template v-slot:schedule_start="{ item }">
              <td class="py-2">
                <DateTimeFormatRangerOnTable
                  :start="item.schedule_start"
                  :end="item.schedule_end"
                />
              </td>
            </template>
            <template v-slot:start="{ item }">
              <td class="py-2">
                <DateTimeFormatRangerOnTable
                  :start="item.start"
                  :end="item.end"
                />
              </td>
            </template>
            <template v-slot:title="{ item }">
              <td>
                <CLink
                  class="feelline-limit-line"
                  :to="`/panel/notification_agentadmin/${item.notification_id}`"
                  >{{ item.title }}</CLink
                >
              </td>
            </template>
            <template v-slot:link="{ item }">
              <td class="py-2">
                <CLink
                  v-if="item.link !== '-'"
                  :href="item.link"
                  target="_blank"
                >
                  <font-awesome-icon size="lg" icon="globe" />
                </CLink>
                <span v-else>
                  {{ item.link }}
                </span>
              </td>
            </template>
            <template v-slot:filter="{ item }">
              <td>
                <CIcon v-if="item.filter === 1" name="cil-user" />
                <CIcon v-else name="cil-people" />
              </td>
            </template>
          </BaseTable>
        </template>
      </BaseCardDetail>
    </div>
  </div>
</template>

<style lang="scss" scoped>
::v-deep .feelline-limit-line {
  display: -webkit-box;
  max-height: 1.2rem;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
}
</style>
